/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_ProducerInputs */

const en_select_producer = /** @type {(inputs: Select_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select producer`)
};

const es_select_producer = /** @type {(inputs: Select_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona productor`)
};

/**
* | output |
* | --- |
* | "Select producer" |
*
* @param {Select_ProducerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_producer = /** @type {((inputs?: Select_ProducerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_ProducerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_producer(inputs)
	return es_select_producer(inputs)
});